// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__z0Ikr","cmsDebug":"Footer_cmsDebug__Kx6lR"};